<template>
  <div>
    <h4 class="text-center">Select Platform</h4>
    <div class="mt-5 list-group">
      <router-link v-for="(platform, key) in availablePlatforms"
                   :key="key"
                   :to="{name: 'administration.channels.new', query: {platform: platform.type}}"
                   class="list-group-item list-group-item-action p-4">
        <wizard-item :icon="platform.icon"
                     :title="platform.type | channelType"></wizard-item>
      </router-link>
    </div>
  </div>
</template>

<script>
  import WizardItem from '@/components/administration/common/WizardItem'
  import facebookMessengerSvg from '@/assets/img/logo/channels/facebook_messenger/facebook_messenger_with_beak.svg'
  import viberSvg from '@/assets/img/logo/channels/viber/viber_with_beak.svg'
  import mobileSvg from '@/assets/img/logo/channels/mobile/mobile_with_beak.svg'
  import rbmSvg from '@/assets/img/logo/channels/rbm/rcs_with_beak.svg'
  import amioChatSvg from '@/assets/img/logo/channels/amio-chat/amio_chat_with_beak.svg'
  import telegram from '@/assets/img/logo/channels/telegram/telegram_with_beak_but_circle.svg'
  import whatsappSvg from '@/assets/img/logo/channels/whatsapp/whatsapp_with_beak.svg'

  const availablePlatforms = [
    {type: 'amio_chat', icon: amioChatSvg},
    {type: 'facebook_messenger', icon: facebookMessengerSvg},
    {type: 'mobile', icon: mobileSvg},
    {type: 'rbm', icon: rbmSvg},
    {type: 'telegram', icon: telegram},
    {type: 'viber', icon: viberSvg},
    {type: 'whatsapp', icon: whatsappSvg}
  ]

  export default {
    components: {
      WizardItem
    },

    data() {
      return {
        availablePlatforms
      }
    }
  }
</script>
